<mat-drawer #summaryDrawer mode="over" style="position: fixed;height:100%; width:380px;border-radius:0 !important;z-index:10000;overflow:auto !important;" position="end" id="summaryDrawer" [(opened)]="vm.isOpen" *ngIf="vm.initialized">
	<div class="c-card" style="height:100%" *ngIf="vm.isOpen">
		<div class="c-content">
			<div class="o-grid">
				<div class="o-grid__cell o-grid__cell--center-v u-no-p">
					<h2 style="font-size: 1.5em !important" class="c-card__title">{{(!vm.isFinalState ? 'Condition_Summary.Title' : 'Condition_Summary.Question') | translate}}</h2>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
					<button id="closeButton" type="button" class="c-button c-button--icon c-button--tp" (click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
					</button>
				</div>
			</div>
		</div>
		<div class="c-content u-no-pt">
			<form class="c-form" name="vm.form" #mainForm="ngForm" (ngSubmit)="vm.handleFormSubmit(mainForm)" *ngIf="!vm.isProcessing">
				<div class="c-form__group u-no-m">
					<div class="c-tags__wrapper">
						<div id="problem{{$index}}"
                             *ngFor="let problem of (vm.isFinalState ? (vm.problems | jsonFilter:{ isSelected: true } ) : vm.problems) ; let $index=index"
							 [ngClass]="{'c-tag--selected': problem.isSelected}"
							 (click)="vm.onProblemClick($event, problem)" class="c-tag">
							{{'Condition_Summary.Problems.' + problem.labelCode | translate}}
						</div>
					</div>
				</div>
				<div class="c-form__group"
					 *ngIf="vm.isCustomTermRequired()"
					 [ngClass]="{'c-form__group--error': vm.submitted && customTerm.invalid}">
					<label for="customTerm" class="c-form__label">{{'Condition_Summary.Problems.OTHER' | translate}}</label>
					<input id="customTerm"
						   name="customTerm"
						   #customTerm="ngModel"
						   type="text"
						   class="c-form__input"
						   [(ngModel)]="vm.customTerm" maxlength="32"
						   [disabled]="vm.isFinalState"
						   required>
				</div>
				<div class="c-form__group" [ngClass]="{'c-form__group--error': vm.submitted && !vm.solution}">
					<label for="solution" class="c-form__label">{{'Condition_Summary.Proposed_Outcome' | translate}}</label>
					<mat-select id="solution" name="solution" [(value)]="vm.solution"
							   class="mat-select mat-select--border" 
							   *ngIf="vm.solutions && vm.solutions?.length > 0"
							   [disabled]="vm.isFinalState"
							   required>
						<mat-option *ngFor="let solution of vm.solutions" [value]="solution">
							{{'Condition_Summary.Solutions.' + solution.labelCode | translate}}
						</mat-option>
					</mat-select>
				</div>
				<div class="c-form__group" [ngClass]="{'c-form__group--error': vm.submitted && refToGpReason.invalid}"
						 *ngIf="vm.solution?.labelCode === 'REF_TO_GP'">
					<label for="refToGpReason" class="c-form__label u-osb-xs" >{{'Condition_Summary.Solutions.REF_TO_GP_REASON' | translate}}</label>
					<input type="text" id="refToGpReason" name="refToGpReason" #refToGpReason="ngModel" class="c-form__input" autocomplete="off" [(ngModel)]="vm.refToGpReason" required/>
				</div>
				<div class="o-grid u-ost-md" *ngIf="!vm.isFinalState">
					<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
						<button id="summarySubmitButton" class="c-button c-button--s1 c-button--fit c-button--lg" type="submit">
							{{ 'Modal.Title.Confirm' | translate }}
						</button>
					</div>
				</div>
				<div class="o-grid u-ost-md" *ngIf="vm.isFinalState">
					<div class="o-grid__cell o-grid__cell--w-50 u-no-pl">
						<button id="summarySubmitYesButton" class="c-button c-button--s1 c-button--fit c-button--lg" type="submit">
							{{ 'Common.Yes' | translate }}
						</button>
					</div>
					<div class="o-grid__cell o-grid__cell--w-50 u-no-pr">
						<button id="summarySubmitCancelButton" class="c-button c-button--s1 c-button--fit c-button--lg" type="button" (click)="vm.isFinalState = false;">
							{{ 'Booking.Button.Back' | translate }}
						</button>
					</div>
				</div>
				<div class="o-grid u-ost-md" *ngIf="!vm.isPreVisit()">
					<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
						<button id="changeToPreVisitFlowButton" class="c-button c-button--s6 c-button--fit c-button--lg" type="button" (click)="vm.changeToPreVisitFlow()">
							{{ 'Condition_Summary.To_Pre_Visit_Flow' | translate }}
						</button>
					</div>
				</div>
			</form>
			<loader-overlay *ngIf="vm.isProcessing"></loader-overlay>
		</div>
	</div>
</mat-drawer>
